module.exports = __webpack_public_path__ + "static/media/message-open.acc7cb5e.svg";